export class EventStack<T> {
  item: T[] = [];
  constructor() {
    this.item = [];
  }
  push(item: T) {
    this.item.push(item);
  }
  peek() {
    return this.item[this.item.length - 1];
  }
  pop() {
    if (this.isEmpty()) return false;
    this.item.pop();
    return true;
  }

  isEmpty() {
    return this.item.length === 0;
  }

  clear() {
    this.item = [];
  }
}
